export default "__VITE_ASSET__BtG4fcbk__"